import { Routes } from '@angular/router';
import { Complete } from './components/complete/complete';
import { File } from './components/file/file';
import { Lookup } from './components/lookup/lookup';
import { Login } from './components/login/login';
import { Verify } from './components/verify/verify';
import { Audit } from './components/audit/audit';
import { AuditComplete } from './components/audit-processing/audit-processing';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'verify' },
  { path: 'file', component: File },
  { path: 'complete', component: Complete },
  { path: 'lookup', component: Lookup },
  { path: 'login', component: Login },
  { path: 'verify', component: Verify },
  { path: 'audit', component: Audit },
  { path: 'audit-processing', component: AuditComplete },

  { path: '**', redirectTo: 'login' },

];
